import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ConfirmModal, MainCard } from 'components';
import RentalForm from '../../components/Rental/RentalForm';
import RentalService from '../../services/rental.service';
import { StatusCell } from '../../components/Rental/RentalsTable';
import SnackbarNotify from '../../utils/snackbar/SnackbarNotify';
import { CANCEL_ALLOWED_STATUSES } from '../../utils/constants/rental-status';
import { Button, Stack } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const EditRental = () => {
    const { rentalId } = useParams();
    const [rental, setRental] = useState(null);
    const { user } = useAuth();

    const navigate = useNavigate();
    const [openCancelModal, setOpenCancelModal] = useState(false);

    const handleCancelRental = async () => {
        try {
            await RentalService.cancelRental(user.active_org_id, rental.rental_id);
            SnackbarNotify.success('Reservation cancelled successfully');
            navigate('/rentals');
        } catch (error) {
            SnackbarNotify.error('Failed to cancel reservation');
        }
    };

    useEffect(() => {
        RentalService.getRentalById(user.active_org_id, rentalId).then(setRental);
    }, [user.active_org_id, rentalId]);

    if (!rental) return <MainCard title="Loading..." />;

    return (
        <>
            <MainCard
                title="Edit Reservation"
                secondary={
                    <Stack direction="row" spacing={2} alignItems="center">
                        <StatusCell value={rental.status} />

                        {CANCEL_ALLOWED_STATUSES.includes(rental.status) && (
                            <Button
                                variant="contained"
                                color="error"
                                size="small"
                                onClick={() => setOpenCancelModal(true)}
                            >
                                Cancel Reservation
                            </Button>
                        )}
                    </Stack>
                }
            >
                <RentalForm selectedRental={rental} isEditMode={true} />
            </MainCard>

            <ConfirmModal
                title="Cancel Reservation"
                text="Are you sure you want to cancel this reservation? This action cannot be undone."
                open={openCancelModal}
                onConfirm={handleCancelRental}
                onClose={() => setOpenCancelModal(false)}
                confirmText="Yes, Cancel"
                cancelText="Keep Reservation"
                type="error"
            />
        </>
    );
};

export default EditRental;
